import script from "./columnBand-v2.vue?vue&type=script&lang=js"
export * from "./columnBand-v2.vue?vue&type=script&lang=js"

import "./columnBand-v2.vue?vue&type=style&index=0&id=999c8cf4&lang=scss"

const __exports__ = script;

export default __exports__